import { useState, useEffect } from 'react';


// eslint-disable-next-line import/prefer-default-export
export const useData = (description, animationSpeed) => {
  const [text, setText] = useState(description);
  const [isHiding, setIsHiding] = useState(false);
  const [isShowing, setIsShowing] = useState(false);

  useEffect(() => {
    let textTimeout;

    if (description === null) {
      setIsHiding(true);
      textTimeout = setTimeout(() => setText(null), animationSpeed);
    } else {
      setIsHiding(false);
      setIsShowing(true);
      setText(description);
    }

    return () => clearTimeout(textTimeout);
  }, [description]);

  useEffect(() => {
    let hidingTimeout;
    let showingTimeout;

    if (isShowing || isHiding) {
      showingTimeout = setTimeout(() => setIsShowing(false), animationSpeed);
      hidingTimeout = setTimeout(() => setIsHiding(false), animationSpeed);
    }
    return () => {
      clearTimeout(showingTimeout);
      clearTimeout(hidingTimeout);
    };
  }, [isShowing, isHiding]);

  return {
    text,
    isHiding,
    isShowing,
  };
};
